import { onMounted, onBeforeUnmount, type Ref } from 'vue'

export function useClickOutside(
  elementRef: Ref<HTMLElement | null>,
  callback: () => void,
) {
  function handler(event: MouseEvent) {
    if (elementRef.value && !elementRef.value.contains(event.target as Node)) {
      callback()
    }
  }

  onMounted(() => document.addEventListener('mousedown', handler, true))
  onBeforeUnmount(() => document.removeEventListener('mousedown', handler, true))
}
